<template>
  <div class="contents">
    <div class="cc-menu">
      <div class="cc-menu-logo">
        <div style="padding: 0px 8px;">
          <img src="@/assets/images/logo.png" alt="" style="width: 45px;height: 45px;">
        </div>
      </div>
      <div class="cc-menu-home cc-handle-scrollbar">
        <div :class="listIndex == -1 ? 'icon-titleclick' : 'icon-title'" @click="onIndex">
          <el-tooltip class="item" effect="dark" content="首页" placement="right">
            <svg class="icon" aria-hidden="true">
              <use :xlink:href="icon"></use>
            </svg>
          </el-tooltip>
        </div>
        <div v-for="(route, index) in sidebarRouters" :key="route.path + index" class="radius">
          <div v-if="route.meta" :class="index == listIndex ? 'icon-titleclick' : 'icon-title'"
            @click="onRoute(route, index)">
            <el-tooltip class="item" effect="dark" :content="route.meta.title" placement="right">
              <item :icon="route.meta && route.meta.icon" />
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="cc-logout" @click="logout">
        <el-tooltip class="item" effect="dark" content="退出登录" placement="right">
          <svg class="icons" aria-hidden="true">
            <use xlink:href="#icon-tuichudenglu1"></use>
          </svg>
        </el-tooltip>
      </div>
    </div>
    <div class="cc-sub-menu cc-handle-scrollbar" v-if="subMenu">
      <span class="metaTitle">{{ currentRoute.meta.title }}</span>
      <div class="cc-sub-menu-item" v-for="(item, index) in currentRoute.children" :key="item.path + index" v-show="item.visible" @click="onSubSkip(item, index)">
        <div :class="index == subIndex ? 'cc-menu-title cc-route-selected' : 'cc-menu-title'">{{ item.meta.title }}</div>
        <div :class="index == subIndex ? 'cc-route-border-selected' : ''" ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Item from './item.vue'
import AppLink from './link'
export default {
    components: { Item, AppLink },
    data() {
        return {
            icon: '#icon-shouye1',
            className: 'route',
            listIndex: -1,
            subIndex: null,
            currentRoute: {},
            subMenu: false,
        }
    },
    watch: {
        '$route': function (to, from) {  //实时监测路由
            for (let i = 0; i < this.currentRoute.children.length; i++) {
                if (to.name == this.currentRoute.children[i].name) {
                    this.subIndex = i
                }
            }
        }
    },
    computed: {
        ...mapGetters(["sidebarRouters",]),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },

    },
    created() {
        let str = this.$route.path
        if (str == '/index') {
            this.listIndex = -1;
            return;
        }
        let text = "/" + str.split('/')[1]
        for (let i = 4; i < this.sidebarRouters.length; i++) {
            let currRoute = this.sidebarRouters[i];
            let routePath = currRoute.path;
            if(i > 4 && !currRoute.alwaysShow){
              routePath = routePath + currRoute.children[0].path
            }
            let isBreak =false;
            if (text == routePath) {
                this.listIndex = i;
                if(currRoute.alwaysShow){
                  if (currRoute.children) {
                    this.currentRoute = currRoute
                    this.subMenu =true;
                    for (let j = 0; j < currRoute.children.length; j++) {
                          if (str.includes(currRoute.children[j].path)) {
                              this.listIndex = i;
                              this.subIndex = j;
                              isBreak = true;
                              break;
                          }
                      }
                    }
                }else{
                  break;
                }
            }
            if(isBreak){
              break;
            }
        }
    },
    methods: {
        onRoute(val, index) {
            this.listIndex = index;
            this.currentRoute = val
            if(val.children != null && val.children.length >0 && val.alwaysShow){
                this.subMenu = true
                let prdfterence  = val.children[0];
                this.onSubSkip(prdfterence,0);
            }else if(val.children != null && !val.alwaysShow){
              this.subMenu = false;
              this.onSkip(val.path + val.children[0].path);
            }
        },
        onIndex() {
            this.listIndex = -1
            this.subMenu = false
            this.$router.push({ path:'/' })
        },
        onSubSkip(val,index){
          this.subIndex = index
          this.onSkip(this.currentRoute.path + '/' + val.path)
        },
        //跳转
        onSkip(skipPath) {
            this.$router.push({ path: skipPath})
        },
        async logout() {
            this.$confirm('确定注销并退出系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('LogOut').then(() => {
                    location.href = '/index';
                })
            }).catch(() => { });
        }
    }
  }
</script>

<style lang="scss" scoped>
.icon {
  width: 25px;
  height: 25px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.contents {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .cc-menu {
    height: 100%;
    background: #FFFFFF;
    border-right: 1px solid #e9eef5;

    .cc-menu-logo {
      height: 8%;
      display: grid;
      align-content: center
    }

    .cc-menu-home {
      height: 80%;
      overflow: auto;

      .icon-title {
        height: 50px;
        border-radius: 20%;
        margin: 10px 5px 5px 5px;
        text-align: center;
        line-height: 60px;
        cursor: pointer;
      }

      .icon-titleclick {
        height: 50px;
        border-radius: 20%;
        background: #e9eef5;
        margin: 10px 5px 5px 5px;
        text-align: center;
        line-height: 60px;
        cursor: pointer;
      }
    }

    .cc-logout {
      height: 9%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      .icons {
        width: 30px;
        height: 30px;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
      }
    }
  }

  .cc-sub-menu {
    width: 130px;
    height: 100%;
    background-color: #FFFFFF;
    overflow: auto;
    .metaTitle {
      text-align: center;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      color: #409EFF;
      margin-left: 30px;
      font-weight: bold;
    }
    .cc-sub-menu-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 130px;
      height: 40px;
      line-height: 40px;
      font-size: 13px;
      font-weight: 500;
     .cc-menu-title{
      padding-left: 15px;
      color: #292a2c;
     }
      :hover {
      cursor: pointer;
      color: #409EFF;
    }
    }
   
  }
  .cc-route-selected{
      color: #409EFF !important;
  }
  .cc-route-border-selected {
    position: relative;
    right: 5px;
    height: 22px;
    width: 3px;
    border-radius: 5px;
    background-color: #409EFF;
  }
}
</style>